import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { OrgResponse, UpdateOrgRequest } from '../types/domain';

export function orgEndpoints(http: HttpClient) {
  return {
    get: () => http.get<ApiEnvelope<OrgResponse>>('/v1/org').then(unwrap),
    update: (body: UpdateOrgRequest) => http.put<ApiEnvelope<OrgResponse>>('/v1/org', body).then(unwrap),
  };
}
export type OrgEndpoints = ReturnType<typeof orgEndpoints>;
